import { Routes, Route, useLocation, Navigate } from 'react-router-dom'
import DataView from './DataView'
import ImportExportPage from './ImportExport'

const DataManagement = () => {
  const { search } = useLocation()

  return (
    <Routes>
      <Route path='data-view/*' element={<DataView />} />
      <Route path='import-export/*' element={<ImportExportPage />} />
      <Route
        path='*'
        element={<Navigate to={`data-view${search}`} replace />}
      />
    </Routes>
  )
}

export default DataManagement
